import { AppBar, Box, Typography, Toolbar, Button } from '@mui/material'
import OverflowText from 'components/ui/OverflowText'
import StatusBadge from 'components/ui/StatusBadge'
import { Document } from 'entities/Documents'
import useRestore from 'hooks/useRestore'
import { useNavigate, useLocation } from 'react-router-dom'

interface Props {
  docDetail: Document
  setOpenDelDialog: (x: boolean) => void
}

function Header({ docDetail, setOpenDelDialog }: Props) {
  const navigate = useNavigate()
  const location = useLocation()
  const restore = useRestore()

  const { documentName, documentStatusNo } = docDetail.docInfo
  const { objectID } = docDetail

  const backToDeleted = () => {
    if (location.state?.fromIndexPage) {
      navigate(-1)
    } else {
      navigate('../deleted')
    }
  }

  const openDelDocDialog = () => {
    setOpenDelDialog(true)
  }

  const handleRestoreClick = () => {
    restore({
      objectIDs: [objectID],
      multi: false,
    }).then((result) => {
      if (result !== 'canceled') {
        navigate(-1)
      }
    })
  }

  return (
    <AppBar position="absolute" sx={{ color: 'text.primary', backgroundColor: 'common.white' }}>
      <Toolbar>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            marginRight: 'auto',
          }}
        >
          <StatusBadge status={documentStatusNo} sx={{ mr: 2 }} />
          <Typography
            variant="h2"
            sx={{
              fontWeight: 'normal',
              fontSize: '1rem',
              maxWidth: '40vw',
            }}
          >
            <OverflowText>{documentName}</OverflowText>
          </Typography>
        </Box>
        <Box sx={{ flexShrink: 0, ml: 2 }}>
          <Button
            color="secondary"
            onClick={backToDeleted}
            variant="outlined"
            data-testid="back-button"
          >
            戻る
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            onClick={handleRestoreClick}
            data-testid="restore-button"
          >
            復元
          </Button>
          <Button
            disableElevation
            variant="contained"
            color="secondary"
            onClick={openDelDocDialog}
            data-testid="delete-button"
          >
            削除
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  )
}

export default Header
